{
	"TelephonenosLabel": "Telephone No(s):",
	"TelephonenosLabelDNIS": "Tel No(s) / DNIS No(s):",
	"TelephonenoDescriptionsLabel": "Telephone No Description(s):",
	"AcdagentsLabel": "ACD Agent(s):",
	"AcdagentsLabel_MST": "Agent(s):",
	"LocationLabel": "Location To/From:",
	"LocationOptionAny": "[Any Call To/From These Locations]",
	"LocationOptionFrom": "Only Calls From These Locations",
	"LocationOptionTo": "Only Calls To These Locations",
	"NAME": "LocationalFiltering",
	"LocationalFiltering_SectionHeader": "Locational Filtering",
	"LocationalFiltering_AnyPlaceholder": "[Any]",
	"LocationalFiltering_DevicesLabel": "Device(s):"
}